<!-- 
    描述：收款账户信息  --  添加收款账户弹窗
    时间：
    Created by 
-->
<template>
    <div class="">
        <el-form
            :model="payObj"
            label-width="200px"
            :rules="payRule"
            ref="payRef"
            v-show="this.num == 0"
        >
            <el-row>
                <el-col :span="12">
                    <el-form-item label="企业名称：" prop="sname">
                        <el-input
                            v-model="payObj.sname"
                            placeholder="请输入企业名称"
                            disabled
                        ></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="统一社会信用机构代码证：" prop="code">
                        <el-input
                            v-model="payObj.code"
                            placeholder="请输入统一社会信用机构代码"
                            disabled
                        ></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="法人代表姓名：" prop="legaler">
                        <el-input
                            v-model="payObj.legaler"
                            placeholder="请输入法人代表姓名"
                            disabled
                        ></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="法人代表身份证：" prop="idCard">
                        <el-input
                            v-model="payObj.idCard"
                            maxlength="18"
                            placeholder="请输入法人代表身份证号码"
                            disabled
                        ></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="法人代表手机号：" prop="legalPhone">
                        <el-input
                            v-model="payObj.legalPhone"
                            maxlength="11"
                            placeholder="请输入法人代表手机号"
                            disabled
                        ></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="开户行：" prop="bank">
                        <el-input
                            v-model="payObj.bank"
                            placeholder="如：“中国工商银行”"
                            :disabled="btnDis"
                        ></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="对公账户：" prop="account">
                        <el-input
                            v-model="payObj.account"
                            placeholder="请输入对公账户"
                            :disabled="btnDis"
                        ></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="开户行支行名称：" prop="branchBank">
                        <el-input
                            v-model="payObj.branchBank"
                            placeholder="如：“中国工商银行股份有限公司北京樱桃园支行”"
                            :disabled="btnDis"
                        ></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="支付行号：" prop="payNo">
                        <el-input
                            v-model="payObj.payNo"
                            placeholder="请输入支付行号"
                            :disabled="btnDis"
                            maxlength="12"
                        ></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="营业执照：" required>
                        <div class="sqh-box">
                            <upload
                                ref="codeUpload"
                                listType="picture-card"
                                tableName="operate_account"
                                assortment="code"
                                :needRefresh="false"
                                :isDisabled="zzDis"
                                :maxNum="1"
                                :aid="objPay.id"
                                :acceptType="accType"
                                :hideTip="true"
                            ></upload>
                            <img
                                @click="showImg"
                                class="temImage"
                                src="@/assets/images/viewTemplate.png"
                                alt
                            />
                        </div>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="法人身份证复印件：" required>
                        <div class="flex">
                            <upload
                                ref="idCardZ"
                                listType="picture-card"
                                tableName="operate_account"
                                assortment="idCardZ"
                                :needRefresh="false"
                                :isDisabled="zDis"
                                :maxNum="1"
                                msg="idCardZ"
                                :aid="objPay.id"
                                :acceptType="accType"
                                :hideTip="false"
                            ></upload>
                            <upload
                                ref="idCardF"
                                listType="picture-card"
                                tableName="operate_account"
                                assortment="idCardF"
                                :needRefresh="false"
                                :isDisabled="fDis"
                                :maxNum="1"
                                class="ml10"
                                :aid="objPay.id"
                                :acceptType="accType"
                                msg="idCardF"
                                :hideTip="false"
                            ></upload>
                        </div>
                        <p>
                            温馨提示：上传文件不超过1M，扫描件或复印件。格式为JPG\JPEG\PNG
                        </p>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
        <el-form
            :model="phoneForm"
            label-width="150px"
            :rules="phoneRule"
            ref="phoneRef"
            v-show="this.num == 1"
        >
            <el-row>
                <el-col :span="12" :offset="6">
                    <el-form-item label="短信接收手机号：" prop="tiedPhone">
                        <el-col :span="15">
                            <el-input
                                v-model="phoneForm.tiedPhone"
                                class="mr10"
                                maxlength="11"
                                placeholder="请输入短信接收手机号"
                            ></el-input>
                        </el-col>
                        <el-col :span="8" :offset="1">
                            <el-button
                                type="primary"
                                class="btn-blue w100"
                                @click="getCode"
                                :disabled="getCodeBtn"
                                id="getCode"
                                >点击获取验证码</el-button
                            >
                        </el-col>
                    </el-form-item>
                </el-col>
                <el-col :span="12" :offset="6" class="mb30">
                    <el-form-item label="手机验证码：" prop="scode">
                        <el-input
                            v-model="phoneForm.scode"
                            placeholder="请输入手机验证码"
                        ></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12" :offset="6">
                    <el-checkbox v-model="checked" @change="stateChange">
                        <span class="agreement" @click="openAgreement"
                            >通联支付网络交易资金管理服务三方协议</span
                        >
                    </el-checkbox>
                </el-col>
            </el-row>
        </el-form>
    </div>
</template>
<script>
import upload from './upload'
import {
    sendVerificationCode,
    selectDeptByUserId
} from 'api/modules/paymentSettlement'
export default {
    components: {
        upload
    },
    props: {
        num: {
            type: Number,
            default: 0
        },
        bizUserId: {
            type: String,
            default: ''
        },
        objPay: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            payObj: {
                sname: '', //企业名称
                code: '', //统一社会信用代码
                legaler: '', //法人代表名称
                idCard: '', //法人代表身份证
                legalPhone: '', //法人代表手机号
                bank: '', //开户行
                account: '', //对公账户
                branchBank: '', //开户支行名称
                payNo: '' //支付行号
            },
            phoneForm: {
                tiedPhone: '',
                scode: ''
            },
            payRule: {
                sname: [
                    {
                        required: true,
                        message: '用户名不能为空',
                        trigger: 'blur'
                    }
                ],
                code: [
                    {
                        required: true,
                        message: '统一社会信用代码不能为空',
                        trigger: 'blur'
                    }
                ],
                legaler: [
                    {
                        required: true,
                        message: '法人代表名称不能为空',
                        trigger: 'blur'
                    }
                ],
                idCard: [
                    {
                        required: true,
                        message: '身份证号不能为空',
                        trigger: 'blur'
                    },
                    {
                        pattern: /(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}$)/,
                        message: '证件号码格式有误！',
                        trigger: 'blur'
                    }
                ],
                legalPhone: [
                    {
                        required: true,
                        message: '手机号不能为空',
                        trigger: 'blur'
                    },
                    {
                        pattern: /^1(3|4|5|6|7|8|9)\d{9}$/,
                        message: '手机号码格式有误！',
                        trigger: 'blur'
                    }
                ],
                bank: [
                    {
                        required: true,
                        message: '开户行不能为空',
                        trigger: 'blur'
                    }
                ],
                account: [
                    {
                        required: true,
                        message: '对公账户不能为空',
                        trigger: 'blur'
                    }
                ],
                branchBank: [
                    {
                        required: true,
                        message: '开户支行名称不能为空',
                        trigger: 'blur'
                    }
                ],
                payNo: [
                    {
                        required: true,
                        message: '支付行号不能为空',
                        trigger: 'blur'
                    }
                ]
            },
            phoneRule: {
                tiedPhone: [
                    {
                        required: true,
                        message: '手机号不能为空',
                        trigger: 'blur'
                    },
                    {
                        pattern: /^1(3|4|5|6|7|8|9)\d{9}$/,
                        message: '手机号码格式有误！',
                        trigger: 'blur'
                    }
                ],
                scode: [
                    {
                        required: true,
                        message: '验证码不能为空',
                        trigger: 'blur'
                    }
                ]
            },
            getCodeBtn: false,
            checked: false,
            bizId: '',
            accType: ['jpg', 'png'],
            btnDis: false,
            zzDis: false,
            zDis: false,
            fDis: false,
            msgDis: false
        }
    },
    mounted() {
        this.selectDeptByUserId()
        if (this.objPay.id) {
            this.dealMsg()
        }
    },
    methods: {
        // 查看模板
        showImg() {
            this.$emit('openDia', true)
        },

        // 获取当前用户信息
        selectDeptByUserId() {
            selectDeptByUserId().then(d => {
                if (d.operationCode == 1) {
                    this.payObj.sname = d.data.sname
                    this.payObj.code = d.data.creditCode
                    this.payObj.legaler = d.data.legal
                    this.payObj.legalPhone = d.data.legalPhone
                    this.payObj.idCard = d.data.legalNo
                    this.bizId = d.data.id
                    this.objPay.id ? (this.payObj = this.objPay) : ''
                }
            })
        },

        // 获取验证码
        getCode() {
            let phone = this.phoneForm.tiedPhone
            if (phone != '') {
                let bizUserId = ''
                if (this.objPay.id) {
                    bizUserId = this.objPay.bizUserid
                } else {
                    bizUserId = this.bizUserId
                }
                sendVerificationCode({
                    tiedPhone: phone,
                    bizUserId: bizUserId
                }).then(d => {
                    if (d.operationCode == 1) {
                        this.$message.success('验证码获取成功,请尽快使用')
                        let getCode = document.querySelectorAll(
                            '#getCode span'
                        )[0]
                        this.getCodeBtn = true
                        let downCount = 60
                        let timeChange = setInterval(() => {
                            downCount -= 1
                            getCode.innerHTML = downCount
                            if (downCount == 0) {
                                clearInterval(timeChange)
                                getCode.innerHTML = '获取授权码'
                                this.getCodeBtn = false
                            }
                        }, 1000)
                    } else {
                        this.$message.error(d.msg)
                    }
                })
            } else {
                this.$message.warning('请填写手机号！')
            }
        },

        // 判断是否审核通过从而禁止相关操作
        dealMsg() {
            this.objPay.list.forEach(item => {
                switch (item.type) {
                    case 0:
                        item.state == 2
                            ? (this.btnDis = false)
                            : (this.btnDis = true)
                        break
                    case 1:
                        item.state == 2
                            ? (this.zzDis = false)
                            : (this.zzDis = true)
                        break
                    case 2:
                        item.state == 2
                            ? (this.zDis = false)
                            : (this.zDis = true)
                        item.state == 2
                            ? (this.fDis = false)
                            : (this.fDis = true)
                        break
                    case 3:
                        item.state == 2
                            ? (this.msgDis = false)
                            : (this.msgDis = true)
                }
            })
        },

        // 同意协议
        stateChange(val) {
            this.$emit('getSumbit', val)
        },

        // 打开协议
        openAgreement() {
            this.$emit('openA')
        },

        //
        getImg(data) {
            this.$emit('sendImg', data)
        }
    },
    computed: {}
}
</script>
<style lang='less' scoped>
.sqh-box {
    display: flex;
    height: 80px;
    .temImage {
        width: 128px;
        height: 80px;
        margin: 0 0 0 15px;
        border-radius: 6px;
        cursor: pointer;
    }
}
.btn-blue.is-disabled {
    color: #fff;
    background-color: rgba(58, 122, 208) !important;
}
.agreement {
    text-decoration: underline;
    color: #2671cc;
}
.agreement:hover {
    color: blue;
}
</style>
